<template>
  <v-container fluid>
    <v-dialog v-model="detail" max-width="800px">
        <v-card v-if="detailItem">
          <v-card-title>
            <h4>Detalles de registro</h4>

          </v-card-title>
          <v-card-text>

            <v-layout row mt-2>
                <v-flex xs12>
                    <h6 class="grey--text">Datos del Equipo</h6>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm3 class="input-group">
                    <label>Nombre</label>
                    <p>
                      {{ detailItem.team_name }}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Liga local</label>
                    <p>
                      {{ detailItem.team_league }}
                    </p>
                </v-flex>

                <v-flex xs12 sm3 class="input-group">
                    <label>Ciudad</label>
                    <p>
                      {{ detailItem.team_city }}
                    </p>
                </v-flex>

            </v-layout>

            <v-layout row mt-2>
                <v-flex xs12>
                    <h6 class="grey--text">Datos del Entrenador</h6>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm3 class="input-group">
                    <label>Nombre</label>
                    <p>
                      {{ detailItem.coach_name }}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Apellido</label>
                    <p>
                      {{ detailItem.coach_lastname }}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Celular</label>
                    <p>
                      {{ detailItem.coach_cellphone }}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Email</label>
                    <p>
                      {{ detailItem.coach_email }}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Pais</label>
                    <p>
                      {{ detailItem.coach_country }}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Estado</label>
                    <p>
                      {{ detailItem.coach_city }}
                    </p>
                </v-flex>

                <v-flex xs12 sm3 class="input-group">
                    <label>Codigo Postal</label>
                    <p>
                      {{ detailItem.coach_postal_code }}
                    </p>
                </v-flex>
            </v-layout>

            <v-layout row mt-2>
                <v-flex xs12>
                    <h6 class="grey--text">Social</h6>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm3 class="input-group">
                    <label>Facebook</label>
                    <p>
                      {{detailItem.fb}}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Instagram</label>
                    <p>
                      {{detailItem.instagram}}
                    </p>
                </v-flex>

            </v-layout>








          </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click.stop="detail=null">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <simple-numeric-input
        @confirm="confirmPriceDialog"
        ref="numbericinput"
        :dialog="priceDialog"
         :labelText="'Total a pagar ' + acceptRegistrationData.currency"
         :default="acceptRegistrationData.defaultPrice"
         positiveText="Aceptar">
       </simple-numeric-input>

    <v-layout row wrap>
      <v-flex xs12  offset-md1 align-center>
        <h3 class="green--text headline mb-0">Registros de equipos</h3>
      </v-flex>



      <v-flex xs5 offset-md1  align-center>
        <v-select
        v-model="filters.year"
        :hint="'Año'"
        :persistent-hint="true"
              :items="currentFilerYears"
              :item-text="'description'"
              :clearable="true"
              label="Select"
              single-line
              bottom
            ></v-select>
      </v-flex>


      <v-flex xs4 offset-md1  align-center>
        <v-select
        v-model="filters.sportPlace"
        :hint="'Liga/Complejo'"
        :persistent-hint="true"
            :items="currentFiltersSportPlaces"
            :item-text="'description'"
            :clearable="true"
              label="Select"
              single-line
              bottom
            ></v-select>
      </v-flex>


      <v-flex xs5 offset-md1  align-center>
        <v-select
        v-model="filters.tournament"
        :hint="'Torneo'"
        :persistent-hint="true"
        :items="tournaments"
        :item-text="'description'"
        :clearable="true"
              label="Select"
              single-line
              bottom
            ></v-select>
      </v-flex>


      <v-flex xs4 offset-md1   align-left>
        <v-select
        v-model="filters.status"
        :hint="'Status de pago'"
        :persistent-hint="true"
        :items="currentFiltersStatus"
        :item-text="'description'"
        :clearable="true"
              label="Select"
              single-line
              bottom
            ></v-select>
      </v-flex>

      <v-flex xs12 offset-md1 align-center>

      </v-flex>

    </v-layout>
    <v-layout row wrap>
      <v-flex xs1 offset-md8>
        <v-btn @click="downloadCSV()" color="primary">
          Descargar CSV
          <v-icon right dark>cloud_download</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs1 offset-md1>
        <v-btn @click="applyFilters()" color="primary">Filtrar</v-btn>
      </v-flex>

      <v-flex xs12 md10 offset-md1>
        <v-data-table
          :rows-per-page-items="[25,50,100]"
          :headers="headers"
          :items="currentFilteredRegistrations"
          class="elevation-1"
          light
          :loading="tableLoading"
          rows-per-page-text="Filas por página"
          >
          <template slot="items" slot-scope="props">
            <td @click.stop="showDetail(props.item)" class="text-xs-left green--text">
                {{ getYear(props.item.registry_date) }}
            </td>
            <td class="text-xs-left grey--text">{{ props.item.team_name  }}</td>
            <td class="text-xs-left grey--text">{{ props.item.sport_place_name }}</td>
            <td class="text-xs-left grey--text">{{ props.item.tournament_name }}</td>
            <td class="text-xs-left grey--text">{{ props.item.payment_status ? "Pagado" : "Pendiente" }}</td>
            <td class="text-xs-left grey--text">
              {{getFormatedDate(props.item.registry_date)}}
            </td>
            <td class="text-xs-left">
              {{props.item.status == 'approved' ? getFormatedDate(props.item.approved_date) : ''}}
            </td>
            <td class="text-xs-left">
              <span v-if="props.item.payment_status">
                <span>ID:</span></br>
                <span>{{ props.item.payment_id  }}</span></br></br>
                <span>Fecha:</span></br>
                <span>{{ getFormatedDate(props.item.payment_at)  }}</span></br>
              </span>
            </td>
            <td class="text-xs-left">
              {{ props.item.deleted_at == null ? props.item.status : 'Archived' }}
            </td>
            <td class="text-xs-left" v-if="props.item.deleted_at == null">
              <v-btn outline @click="acceptRegistratios(props.item,props.item.tournament_id,true)" v-if="props.item.payment_status != true && props.item.status != 'approved' " color="primary" small light flat>Aceptar</v-btn>
              <v-btn outline @click="acceptRegistratios(props.item,props.item.tournament_id,false)" v-if="props.item.payment_status != true && props.item.status != 'rejected'"  color="error" small light flat>Rechazar</v-btn>
              <v-btn outline @click="markaAsPaid(props.item,props.item.tournament_id)" v-if="props.item.payment_status != true"  color="error" small light flat>Marcar como pagado</v-btn>
              <v-btn outline @click="archiveRegistration(props.item.id,props.item.tournament_id)"   color="error" small light flat>Archivar</v-btn>
            </td>
            <td class="text-xs-left" v-if="props.item.deleted_at != null">

            </td>

          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import Bus from '@/components/bus'
import moment from 'moment'
import SimpleNumericInput from '@/components/helpers/modals/SimpleNumericInput'


export default {
  name: "TournamentsRegistrationsStatistics",
  data: () => ({
    filters:{
      year:null,
      tournament:null,
      status:null,
      sportPlace:null
    },
    priceDialog:false,
    acceptRegistrationData:{},
    acceptAndMarkAsPaid:false,
    confirmMessage:"",
    detailItem: null,
    detail:false,
    filter: '',
    actionSelected: '',
    userSelected: [],
    // Muestra un pequeño loading encima de la tabla dependiendo de su valor (True, False)
    tableLoading: false,
    headers: [
      { text: 'Año', value: '', align: 'left' },
      { text: 'Equipo', value: '', align: 'left' },
      { text: 'Complejo', value: '', align: 'left' },
      { text: 'Torneo', value: '', align: 'left' },
      { text: 'Estado de pago', value: '', align: 'left' },
      { text: 'Fecha de inscripción', value: '', align: 'left' },
      { text: 'Fecha de aprobación', value: '', align: 'left' },
      { text: 'Info del pago', value: '', align: 'left' },
      { text: 'Estado de registro', value: '', align: 'left' },
      { text: 'Acciones', value: '', align: 'left' }
      ]
  }),
  created() {
    //do something after creating vue instance
    this.loadFilterYears()
    this.loadFilterSportPlaces()
    this.loadFilterTournaments()
    this.loadFilterStatus()
    this.applyFilters()
  },
  mounted(){
    console.log("MOUNTED", this.$route.params.tournamentID)
  },
  computed: {
    tournaments(){
      if(this.filters.sportPlace){
        var result = []
        for(var i in this.currentFiltersTournaments){
          if(this.currentFiltersTournaments[i].sport_place == this.filters.sportPlace.id){
            result.push(this.currentFiltersTournaments[i])
          }
        }
        return result
      }
      return this.currentFiltersTournaments
    },
    ...mapGetters([
      'getRegistrations',
      'currentFilerYears',
      'currentFiltersTournaments',
      'currentFiltersStatus',
      'currentFiltersSportPlaces',
      'currentFilteredRegistrations'

    ]),
    ...mapGetters('loading', [
      'isLoading',
      'anyLoading',
    ])
  },
  methods: {
    ...mapActions([
      'loadFilterYears',
      'loadFilterSportPlaces',
      'loadFilterTournaments',
      'loadFilterStatus',
      'activeUser',
      'resolveRegistrationsHasStatisticsAdmin',
      'acceptAndMarkAsPaidARegistrationHasStatisticsAdmin',
      'archiveRegistrationsHasStatisticsAdmin',
      'loadFilteredRegistrations',
      'downloadRegistrationsCSV'
    ]),
    getYear(date){
      var localLocale = moment(date);
      moment.locale('es');
      localLocale.locale(false);
      return localLocale.format('YYYY')
    },
    getFormatedDate(date){
      var localLocale = moment(date);
      moment.locale('es');
      localLocale.locale(false);
      return localLocale.format('MMMM DD [del] YYYY [a] hh:mm a')
    },
    showDetail(item){
      this.detailItem = item
      this.detail = true
    },
    acceptRegistratios(reg,tournamentId,accept){


      this.acceptRegistrationData.defaultPrice = reg.tournament_price
      this.acceptRegistrationData.currency = reg.tournament_currency
      this.acceptRegistrationData.tournamentId = tournamentId
      this.acceptRegistrationData.registrationId =  reg.id
      this.acceptRegistrationData.accepted = accept
      this.acceptRegistrationData.callBack = ()=>{
        this.applyFilters()
      }
      if(!accept){
        this.resolveRegistrationsHasStatisticsAdmin(this.acceptRegistrationData)
      }else{
        this.priceDialog = true
      }
      console.log("acceptRegistratios",this.acceptRegistrationData)
      //this.resolveRegistrationsHasStatisticsAdmin(data)
    },
    markaAsPaid(reg,tournamentId){
      this.acceptRegistrationData.defaultPrice = reg.tournament_price
      this.acceptRegistrationData.currency = reg.tournament_currency
      this.acceptRegistrationData.tournamentId = tournamentId
      this.acceptRegistrationData.registrationId =  reg.id
      this.acceptRegistrationData.callBack = ()=>{
        this.applyFilters()
      }

      this.acceptAndMarkAsPaid = true
      this.priceDialog = true
    },
    confirmPriceDialog(confirm,value){
      if(!confirm){this.priceDialog = false; return;}
      if(value && Number(value)>0){
        this.priceDialog = false
        this.acceptRegistrationData.ammount = Number(value)
        if(this.acceptAndMarkAsPaid){
          this.acceptAndMarkAsPaid = false
          this.acceptAndMarkAsPaidARegistrationHasStatisticsAdmin(this.acceptRegistrationData)
          return;
        }
        this.resolveRegistrationsHasStatisticsAdmin(this.acceptRegistrationData)
      }
    },
    archiveRegistration(id,tournamentId){
      let data = {
        tournamentId:tournamentId,
        registrationId: id,
        callBack: ()=>{
          this.applyFilters()
        }
      }
      console.log("DATA",data)
      this.archiveRegistrationsHasStatisticsAdmin(data)
    },
    applyFilters(){
      this.loadFilteredRegistrations(this.filters)
    },
    downloadCSV(){

      var year_filter = 0
      var sport_place_filter = 0
      var tournament_filter = 0
      var city_filter = 0
      var paid_status_filter = 0
      if(this.filters.year){
        year_filter = this.filters.year.id
      }
      if(this.filters.tournament){
        tournament_filter = this.filters.tournament.id
      }
      if(this.filters.status){
        paid_status_filter = this.filters.status.id
      }
      if(this.filters.sportPlace){
        sport_place_filter= this.filters.sportPlace.id
      }
      let url =Vue.config.PITZ.API_URL+`/statistics/get_suscriptions_csv/${year_filter}/${sport_place_filter}/${tournament_filter}/${city_filter}/${paid_status_filter}`
      Vue.axios({
        url: url,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.csv');
        document.body.appendChild(link);
        link.click();
      })
      //this.downloadRegistrationsCSV(this.filters)
    }

  }

}
</script>

<style lang="css" scoped>
select{
  border: 1px solid;
  padding: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/statistics/tournamentsRegistrationsStatistics.vue